import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'Mahinda Rajapakshe ',
    status : ' ENTREPRENEUR'
  },
  {
    image: image2,
    review: "Joining Fitclub was the best decision of my life! The personalized plan and program I chose helped me not only reach but surpass my fitness goals. Iam now living my healthiest and happiest life, all thanks to Fitclub",
    name: 'AKD',
    status: 'COACH'
  },
  {
    image : image3,
    review:"I can't believe the incredible transformation I've experienced since joining Fitclub and selecting the perfect plan for me. The results speak for themselves, and I've achieved my dream body faster than I ever thought possible. Fitclub is a game-changer",
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
